/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommunicationNote
 */
export interface CommunicationNote {
    /**
     * 
     * @type {string}
     * @memberof CommunicationNote
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationNote
     */
    patient_id: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationNote
     */
    staff_id?: string;
    /**
     * 
     * @type {number}
     * @memberof CommunicationNote
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunicationNote
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationNote
     */
    note?: string;
}

/**
 * Check if a given object implements the CommunicationNote interface.
 */
export function instanceOfCommunicationNote(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;

    return isInstance;
}

export function CommunicationNoteFromJSON(json: any): CommunicationNote {
    return CommunicationNoteFromJSONTyped(json, false);
}

export function CommunicationNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommunicationNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'patient_id': json['patient_id'],
        'staff_id': !exists(json, 'staff_id') ? undefined : json['staff_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CommunicationNoteToJSON(value?: CommunicationNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'patient_id': value.patient_id,
        'staff_id': value.staff_id,
        'date': value.date,
        'medium': value.medium,
        'note': value.note,
    };
}

